

export default function initHeader() {
	const burger = document.querySelector('.header__burger');
	const menu = document.querySelector('.menu');
	const header = document.querySelector('.header');

	burger.addEventListener('click', () => {
		menu.classList.toggle('show');
		header.classList.toggle('menu-open');
	});

	document.addEventListener("scroll", (event) => {
	  if(window.scrollY > 50 && !header.classList.contains('scrolled')) {
	  	header.classList.add('scrolled');
	  }

	  if(window.scrollY <= 50) {
	  	header.classList.remove('scrolled');
	  }
	});



	// submenu 

	const parents = menu.querySelectorAll('.parent');

	parents.forEach(parent => {
		const link = parent.querySelector('.menu__nav__item__link');

		link.addEventListener('click', (e) => {
			
			e.preventDefault();

			if(link.parentElement.classList.contains('show-submenu')) {
				link.parentElement.querySelector('.submenu').classList.remove('show');
				link.parentElement.classList.remove('show-submenu');
			} else {

				if(document.querySelector('.submenu.show')) document.querySelector('.submenu.show').classList.remove('show');
				if(document.querySelector('.show-submenu')) document.querySelector('.show-submenu').classList.remove('show-submenu');
				link.parentElement.querySelector('.submenu').classList.toggle('show');
				link.parentElement.classList.toggle('show-submenu');
			}
		});
	}); 
}